import { AutoPlayService } from './service/AutoPlayService'

export type AutoPlayOptionType = 'infinity' | number

export const autoPlayOptions: AutoPlayOptionType[] = [10, 50, 100, 'infinity']
export const autoPlayOptionsV2: AutoPlayOptionType[] = [20, 50, 100, 1000, 'infinity']

export const autoPlayService = new AutoPlayService()
